<template>
  <div class="w-10">
    <img src="/favicon.png" alt="ČEZ logo" class="rounded" />
  </div>
</template>
